// extracted by mini-css-extract-plugin
module.exports = {"productAnimation":"ProductAnimation_productAnimation__DlL0y","ef-box":"ProductAnimation_ef-box__33Rer"};